// ===== Packages =====

import {
    doc,
    getFirestore,
    onSnapshot,
    Unsubscribe,
}                           from 'firebase/firestore';

// ===== Interfaces =====

import {
    IPostCollabDocItem,
}                           from '../interfaces';

// ===== Enums =====

import {
    FIRESTORE_COLLECTION,
}                           from '../enums';

const subscribeToPostCollabDoc = ({
    test,
    docId,
    onNext,
}: {
    test: boolean,
    docId: string,
    onNext: (postCollabDoc: IPostCollabDocItem | null) => void,
}): Unsubscribe => {
    const firestore = getFirestore();
    const collabCollection = test
        ? FIRESTORE_COLLECTION.stagingPostCollabDocs
        : FIRESTORE_COLLECTION.postCollabDocs;

    return onSnapshot(
        doc(firestore, collabCollection, docId),
        (snapshot) => {
            if (!snapshot.exists()) {
                onNext(null);
                return;
            }
            onNext(snapshot.data() as IPostCollabDocItem);
        },
        () => onNext(null),
    );
};

export default subscribeToPostCollabDoc;
